var render = function render(){var _vm=this,_c=_vm._self._c;return _c('confirm-modal',{attrs:{"visible":_vm.dialogVisible,"title":_vm.modalTextos.titulo,"leftButton":{
    show: true,
    text: _vm.i18n.geral.cancelar,
    closeOnClick: true
  },"rightButton":{
    show: true,
    text: _vm.i18n.geral.confirmar,
    onClick: _vm.handleConfirm
  }},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('p',{staticClass:"modal-descricao",domProps:{"innerHTML":_vm._s(_vm.modalTextos.descricao)}}),_c('label',{staticClass:"modal-label"},[_vm._v(_vm._s(_vm.i18n.conta.login.labelCpfPassaporte))]),_c('input-cpf-passaporte',{attrs:{"value":_vm.value,"placeholder":_vm.i18n.conta.login.placeholderCpfPassaporte,"border-color":"#295661"},on:{"input":function($event){return _vm.$emit('input', $event)},"enter":_vm.handleConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }